import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { footerData } from "../assets/data/Data";
import { fontFamilyAll } from "../assets/commonComponents/COLORS";

const Footer = () => {
  return (
    <Box sx={{ textAlign: "center", mt: 5, opacity: 0.7, py: 2, color: "white" }}>
      <Divider sx={{ backgroundColor: "gray", mb: 1 }} />
      <Typography variant="body2"  fontFamily={fontFamilyAll}>{footerData}</Typography>
    </Box>
  );
};

export default Footer;
